import staffFetch from "./staffFetch";
import React, { useEffect, useMemo, useState } from "react";

const API = "https://live-evo.com/api";

function StaffSupportTicketsPage() {
  const [tickets, setTickets] = useState([]);
  const [quickReplies, setQuickReplies] = useState([]);
  const [showQuickReplies, setShowQuickReplies] = useState(false);
  const [replyMessage, setReplyMessage] = useState("");
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [filter, setFilter] = useState("all");

  const loadTickets = async () => {
    try {
      const res = await staffFetch(`${API}/support/getTickets`);
      const data = await res.json();
      setTickets(Array.isArray(data) ? data : []);
    } catch (e) {
      console.log("Erreur tickets:", e);
    }
  };

  const loadQuickReplies = async () => {
    try {
      const res = await staffFetch(`${API}/staff/replies`);
      const data = await res.json();
      setQuickReplies(Array.isArray(data?.replies) ? data.replies : []);
    } catch (e) {
      console.log("Erreur réponses rapides:", e);
    }
  };

  useEffect(() => {
    loadTickets();
    loadQuickReplies();

    const interval = setInterval(() => {
      loadTickets();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const selectedTicket = useMemo(() => {
    return tickets.find((t) => t.id === selectedTicketId) || null;
  }, [tickets, selectedTicketId]);

  const filteredTickets = useMemo(() => {
    if (filter === "all") return tickets;
    return tickets.filter((t) => String(t.status || "") === filter);
  }, [tickets, filter]);

  const closeTicket = async (id) => {
    try {
      await staffFetch(`${API}/support/close`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ticket_id: id
        })
      });

      alert("Ticket fermé");
      loadTickets();
    } catch (e) {
      console.log(e);
      alert("Erreur fermeture ticket");
    }
  };

  const deleteTicket = async (id) => {
    try {
      await staffFetch(`${API}/support/delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ticket_id: id
        })
      });

      alert("Ticket supprimé");

      if (selectedTicketId === id) {
        setSelectedTicketId(null);
        setReplyMessage("");
        setShowQuickReplies(false);
      }

      loadTickets();
    } catch (e) {
      console.log(e);
      alert("Erreur suppression ticket");
    }
  };

  const replyTicket = async () => {
    if (!selectedTicketId || replyMessage.trim() === "") {
      alert("Message vide");
      return;
    }

    try {
      await staffFetch(`${API}/support/reply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ticket_id: selectedTicketId,
          message: replyMessage
        })
      });

      alert("Réponse envoyée");
      setReplyMessage("");
      setShowQuickReplies(false);
      loadTickets();
    } catch (e) {
      console.log(e);
      alert("Erreur envoi réponse");
    }
  };

  const handleQuickReply = (message) => {
    setReplyMessage(message);
    setShowQuickReplies(false);
  };

  const renderConversation = (item) => {
    const history = [];

    if (item.message) {
      history.push({
        type: "user",
        label: "UTILISATEUR",
        message: item.message
      });
    }

    if (Array.isArray(item.messages) && item.messages.length > 0) {
      item.messages.forEach((msg, index) => {
        history.push({
          key: `msg-${index}`,
          type: msg.sender === "staff" ? "staff" : "user",
          label: msg.sender === "staff" ? "STAFF" : "UTILISATEUR",
          message: msg.message
        });
      });
    } else if (item.reply) {
      history.push({
        type: "staff",
        label: "STAFF",
        message: item.reply
      });
    }

    return (
      <div style={{ marginTop: 10 }}>
        {history.map((msg, index) => (
          <div
            key={msg.key || `${msg.type}-${index}`}
            style={{
              padding: 10,
              borderRadius: 10,
              marginTop: 8,
              background: msg.type === "staff" ? "#061316" : "#101010",
              borderLeft: msg.type === "staff" ? "3px solid #00f2ff" : "3px solid #555"
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: 11,
                marginBottom: 4,
                color: msg.type === "staff" ? "#00f2ff" : "#aaa"
              }}
            >
              {msg.label}
            </div>

            <div style={{ color: "#e6e6e6", fontSize: 14, lineHeight: "20px", whiteSpace: "pre-wrap" }}>
              {msg.message}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div style={{ background: "#000", minHeight: "100vh", color: "#fff", padding: 18 }}>
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <button
          onClick={() => window.location.href = "/staff"}
          style={backBtn}
        >
          ← Retour Dashboard
        </button>

        <h1 style={{ color: "#00f2ff", marginBottom: 10 }}>📩 Tickets support</h1>

        <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" }}>
          {["all", "open", "closed"].map((item) => (
            <button
              key={item}
              onClick={() => setFilter(item)}
              style={{
                border: filter === item ? "1px solid #00f2ff" : "1px solid #222",
                background: filter === item ? "#061316" : "#0b0b0b",
                color: filter === item ? "#00f2ff" : "#666",
                padding: "9px 14px",
                borderRadius: 10,
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              {item.toUpperCase()}
            </button>
          ))}
        </div>

        {filteredTickets.length === 0 ? (
          <div style={{ color: "#444", textAlign: "center", marginTop: 40 }}>
            Aucun ticket à traiter 🥂
          </div>
        ) : (
          filteredTickets.map((item) => {
            const isSelected = selectedTicketId === item.id;

            return (
              <div
                key={item.id}
                onClick={() => setSelectedTicketId(item.id)}
                style={{
                  border: isSelected ? "1px solid #00f2ff" : "1px solid #1a1a1a",
                  padding: 15,
                  borderRadius: 12,
                  marginBottom: 12,
                  background: "#050505",
                  cursor: "pointer"
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                  <div style={{ color: "#00f2ff", fontWeight: "bold", fontSize: 13 }}>
                    {item.user_email}
                  </div>

                  <div
                    style={{
                      color: item.status === "open" ? "#00f2ff" : "#777",
                      fontWeight: "900",
                      fontSize: 10,
                      letterSpacing: 1
                    }}
                  >
                    {String(item.status || "").toUpperCase()}
                  </div>
                </div>

                <div style={{ color: "#fff", marginTop: 8, fontWeight: "bold", fontSize: 15 }}>
                  {item.subject}
                </div>

                {renderConversation(item)}

                <div style={{ display: "flex", marginTop: 15, flexWrap: "wrap", gap: 8 }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedTicketId(item.id);
                    }}
                    style={outlineBtn}
                  >
                    RÉPONDRE
                  </button>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      closeTicket(item.id);
                    }}
                    style={cyanBtn}
                  >
                    FERMER
                  </button>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteTicket(item.id);
                    }}
                    style={deleteBtn}
                  >
                    SUPPRIMER
                  </button>
                </div>
              </div>
            );
          })
        )}

        {selectedTicket && (
          <div style={replyBox}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ color: "#00f2ff", fontWeight: "bold", fontSize: 13 }}>
                Répondre au ticket #{selectedTicket.id}
              </div>

              <button
                onClick={() => {
                  setSelectedTicketId(null);
                  setReplyMessage("");
                  setShowQuickReplies(false);
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#ff3b30",
                  fontWeight: "bold",
                  fontSize: 16,
                  cursor: "pointer"
                }}
              >
                X
              </button>
            </div>

            <div style={{ maxHeight: 220, overflow: "auto", marginBottom: 10 }}>
              {renderConversation(selectedTicket)}
            </div>

            <button
              onClick={() => setShowQuickReplies(!showQuickReplies)}
              style={{
                border: "1px solid #00f2ff",
                padding: 10,
                borderRadius: 10,
                marginBottom: 8,
                background: "#061316",
                color: "#00f2ff",
                fontWeight: "bold",
                width: "100%",
                cursor: "pointer"
              }}
            >
              ⚡ Réponses rapides
            </button>

            {showQuickReplies && (
              <div style={quickList}>
                {quickReplies.length === 0 ? (
                  <div style={{ color: "#777", textAlign: "center", fontSize: 12, padding: 8 }}>
                    Aucune réponse rapide disponible.
                  </div>
                ) : (
                  quickReplies.map((reply) => (
                    <div
                      key={reply.id}
                      onClick={() => handleQuickReply(reply.message)}
                      style={{
                        borderBottom: "1px solid #151515",
                        padding: "8px 0",
                        cursor: "pointer"
                      }}
                    >
                      <div style={{ color: "#ffcc00", fontSize: 10, fontWeight: "bold", marginBottom: 3 }}>
                        {String(reply.category || "support").toUpperCase()}
                      </div>
                      <div style={{ color: "#00f2ff", fontWeight: "bold", fontSize: 12, marginBottom: 3 }}>
                        {reply.title}
                      </div>
                      <div style={{ color: "#ccc", fontSize: 11, lineHeight: "16px" }}>
                        {reply.message}
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}

            <textarea
              placeholder="Votre réponse..."
              value={replyMessage}
              onChange={(e) => setReplyMessage(e.target.value)}
              style={textArea}
            />

            <button onClick={replyTicket} style={sendBtn}>
              ENVOYER LA RÉPONSE
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const backBtn = {
  marginBottom: 15,
  padding: "8px 0",
  color: "#00f2ff",
  fontSize: 16,
  fontWeight: "bold",
  background: "transparent",
  border: "none",
  cursor: "pointer"
};

const outlineBtn = {
  background: "#000",
  border: "1px solid #00f2ff",
  color: "#00f2ff",
  padding: "8px 12px",
  borderRadius: 8,
  fontWeight: "bold",
  fontSize: 11,
  cursor: "pointer"
};

const cyanBtn = {
  background: "#00f2ff",
  color: "#000",
  border: "none",
  padding: "8px 12px",
  borderRadius: 8,
  fontWeight: "bold",
  fontSize: 11,
  cursor: "pointer"
};

const deleteBtn = {
  background: "#1a1a1a",
  border: "1px solid #ff3b30",
  color: "#ff3b30",
  padding: "8px 12px",
  borderRadius: 8,
  fontWeight: "bold",
  fontSize: 11,
  cursor: "pointer"
};

const replyBox = {
  background: "#0a0a0a",
  border: "1.5px solid #00f2ff",
  padding: 15,
  borderRadius: 15,
  marginTop: 10,
  marginBottom: 30
};

const quickList = {
  background: "#050505",
  border: "1px solid #12344a",
  borderRadius: 10,
  padding: 8,
  marginBottom: 8,
  maxHeight: 230,
  overflow: "auto"
};

const textArea = {
  border: "1px solid #333",
  borderRadius: 10,
  padding: 12,
  color: "#fff",
  background: "#000",
  marginBottom: 10,
  minHeight: 100,
  width: "100%",
  resize: "vertical"
};

const sendBtn = {
  background: "#00f2ff",
  color: "#000",
  border: "none",
  padding: 15,
  borderRadius: 10,
  fontWeight: "bold",
  width: "100%",
  cursor: "pointer"
};

export default StaffSupportTicketsPage;